import type { InputHTMLAttributes, ReactNode } from 'react';
import './Input.css';

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'prefix'> {
  label?: string;
  required?: boolean;
  mono?: boolean;
  prefix?: ReactNode;
  error?: string;
  hint?: string;
}

export function Input({
  label,
  required = false,
  mono = false,
  prefix,
  error,
  hint,
  id,
  style,
  className = '',
  ...rest
}: InputProps) {
  const fid = id ?? (label ? `f-${String(label).toLowerCase().replace(/\s+/g, '-')}` : undefined);
  return (
    <div className="uc-field" style={style}>
      {label && (
        <label className="uc-field__label" htmlFor={fid}>
          {label}
          {required && <span className="uc-field__req">*</span>}
        </label>
      )}
      <div className="uc-input-wrap">
        {prefix && <span className="uc-input__prefix">{prefix}</span>}
        <input
          id={fid}
          className={`uc-input${mono ? ' uc-input--mono' : ''}${error ? ' uc-input--invalid' : ''}${prefix ? ' uc-input--has-prefix' : ''} ${className}`}
          aria-invalid={Boolean(error)}
          {...rest}
        />
      </div>
      {error ? (
        <span className="uc-field__msg uc-field__msg--err">{error}</span>
      ) : hint ? (
        <span className="uc-field__msg uc-field__msg--hint">{hint}</span>
      ) : null}
    </div>
  );
}
